/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Rain_Showers_LightInputs */

const en_ui_weather_rain_showers_light = /** @type {(inputs: Ui_Weather_Rain_Showers_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light rain showers`)
};

const de_ui_weather_rain_showers_light = /** @type {(inputs: Ui_Weather_Rain_Showers_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichte Regenschauer`)
};

/**
* | output |
* | --- |
* | "Light rain showers" |
*
* @param {Ui_Weather_Rain_Showers_LightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rain_showers_light = /** @type {((inputs?: Ui_Weather_Rain_Showers_LightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Rain_Showers_LightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rain_showers_light(inputs)
	return de_ui_weather_rain_showers_light(inputs)
});